import { createPinia } from 'pinia';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import { createApp } from 'vue';
import Toast, { POSITION, useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import { setApiToast } from '@/api/base';
import App from '@/App.vue';
import router from '@/router/router';

import '@/styles/main.scss';

import { Notifier } from '@airbrake/browser';
//Import Mixpanel SDK
import mixpanel from "mixpanel-browser";

const toastOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  maxToasts: 3,
  newestOnTop: true
};
const pinia = createPinia();
const app = createApp(App);
if (import.meta.env.PROD) {
  const airbrake = new Notifier({
    environment: 'production',
    projectId: 654001,
    projectKey: '9c3bc8f04d2edca0275e675ad5b55757'
  });
  app.provide('airbrake', airbrake);
  app.config.errorHandler = (err, vm, info) => {
    airbrake.notify({
      error: err,
      params: { info: info }
    });
  };
  window.addEventListener('error', (event) => {
    airbrake.notify({
      error: event.error,
      params: { event }
    });
  });
  window.addEventListener('unhandledrejection', (event) => {
    airbrake.notify({
      error: event.reason,
      params: { event }
    });
  });
  // Create an instance of the Mixpanel object, your token is already added to this snippet
  mixpanel.init('9e33d18212960b11f934a62e9cd9f19a', {
    autocapture: false,
    record_sessions_percent: 10,  	//records 1% of all sessions
    record_idle_timeout_ms: 1800000, //End a replay capture after 30mins of inactivity
    ignore_dnt: true,
    api_host: 'https://track.nextbase-teamcloud.com',
    persistence: 'localStorage'
  });
  app.provide('mixpanel', mixpanel);
}
app.use(Toast, toastOptions);
app.use(VCalendar, {});
// セッション確認の結果に関わらずルーターを設定してアプリを起動
app.use(router);
app.use(pinia);
app.runWithContext(() => {
  setApiToast(useToast());
});
app.mount('#app');
